"use strict"

import React, {useState} from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Container, Grid, Typography} from "@material-ui/core"

import Login from "./login"
import ForgotPassword from "./forgotPassword"

import LoginStore from "./loginStore"
import settings from "../../global/config/settings"

function getScreen(screen) {
	switch (screen) {
		case LoginStore.screens.FORGOT:
			return <ForgotPassword />
		default:
			return <Login />
	}
}

function getHeaderText(screen) {
	switch (screen) {
		case LoginStore.screens.FORGOT:
			return <Typography variant="h3">Resetovať heslo</Typography> //Obnovenie prihlasovacích údajov
		default:
			return (
				<Typography variant="h3">
					Vitajte na portáli INOWA {settings.SERVERROLE != "PROD" && settings.SERVERROLE}
				</Typography>
			)
	}
}

const maintenanceScreen = (
	<React.Fragment>
		<Container maxWidth="lg">
			<Grid container justify="center">
				<Grid item xs={12}>
					<Grid container direction="row" justify="center" style={{height: "40vh", marginTop: "10vh"}}>
						<Grid item xs={12}>
							<Typography variant="h4" color="primary">
								Plánovaná údržba INOWA 09.-16.06.2025
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5" color="primary">
								Pre plánovanú údržbu portálu INOWA nebude v dňoch 09.06.2025 až 16.06.2025 možná registrácia ani vstup
								do vášho už vytvoreného užívateľského konta.
							</Typography>
							<Typography variant="h5" color="primary">
								Prístup k portálu INOWA bude opäť plne funkčný od 17.06.2025.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5" color="primary">
								Ďakujeme za pochopenie.
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	</React.Fragment>
)

function LoginContainer() {
	const [isMaintenance] = useState(false)

	return (
		<React.Fragment>
			<div className="main_header">
				<Container style={{maxWidth: "90%"}}>
					<Grid container alignItems="center" justify="space-between" className="pt-2 pb-2">
						<Grid item>
							<img
								src="/public/images/siea_a_inovujme.png"
								style={{width: "470px", height: "100px"}}
								className="pointer"
								onClick={() => (LoginStore.screen = LoginStore.screens.LOGIN)}
							/>
						</Grid>
						<Grid item className="header_gradient">
							{getHeaderText(LoginStore.screen)}
						</Grid>
						<Grid item style={{width: 470}}></Grid>
					</Grid>
				</Container>
			</div>
			{isMaintenance && maintenanceScreen}
			{!isMaintenance && (
				<Container maxWidth="lg">
					<Grid container justify="center">
						<Grid
							item
							style={{
								maxWidth: "400px",
								width: "400px"
							}}
						>
							<Grid container direction="column" justify="center" style={{height: "65vh"}}>
								{getScreen(LoginStore.screen)}
							</Grid>
						</Grid>
					</Grid>
				</Container>
			)}
		</React.Fragment>
		// <React.Fragment>
		// 	<AppBar position="static" alignitems="center">
		// 		<Toolbar className="main_toolbar">
		// 			<Grid container>
		// 				<Grid item>
		// 					<img src="/public/images/logo.png" />
		// 				</Grid>
		// 			</Grid>
		// 		</Toolbar>
		// 	</AppBar>
		// 	<Grid container justify="center">
		// 		<Grid item style={{maxWidth: "400px", width: "400px"}}>
		// 			<Grid container direction="column" justify="center" style={{height: "80vh"}}>
		// 				{getScreen(LoginStore.screen)}
		// 			</Grid>
		// 		</Grid>
		// 	</Grid>
		// </React.Fragment>
	)
}

export default injectIntl(observer(LoginContainer))

